import { AccordionDetails, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import DamHelper, { IDam } from '../../../@types/model/dam/dam';
import DamInspectionHelper, { IDamInspection } from '../../../@types/model/dam/damInspection';
import AppFunctionsService from '../../../services/appFunctionsService';
import GeneralFunctions from '../../../store/general/functions';
import PrimaryAccordionSummary from '../../customComponents/expansion/PrimaryAccordionSummary';
import SeparatedAccordion from '../../customComponents/expansion/SeparatedAccordion';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DamInspectionEntryView from './DamInspectionEntryView';

interface IDamInspectionProps {
    dam : IDam;
}

interface IDamInspectionState {
    damInspections : Array<IDamInspection>;
    isLoading : boolean;
}

export default class DamInspection extends React.PureComponent<IDamInspectionProps, IDamInspectionState> {
    private listener ?: () => void;

    constructor(props : IDamInspectionProps) {
        super(props);
        this.state = {
            isLoading: false,
            damInspections: [],
        };
    }

    public componentWillUnmount() : void {
        if (this.listener) this.listener();
    }

    public componentDidMount() : void {
        this.load();
    }

    public readonly load = () => {
        if (this.listener) this.listener();

        this.setState({
            damInspections: [],
            isLoading: true,
        });

        this.listener = DamInspectionHelper.collection()
            .where('dam', '==', DamHelper.doc(this.props.dam.id))
            .orderBy('date', 'desc')
            .onSnapshot((snapshot) => {
                if (!this.listener) return;
                this.setState({
                    damInspections: snapshot.docs.map(x => x.data()),
                    isLoading: false,
                });
            }, (error) => {
                GeneralFunctions.generalShowError(error, 'Error Loading Inspection Inspections');
            }, () => {
                this.listener = undefined;
            });
    };

    public readonly render = () => {
        const { damInspections, isLoading } = this.state;

        return (
            <div className={'fdc flx1 bcg0 oya'}>
                {
                    isLoading &&
                    <div className='fdc flx1 aic jcc'>
                        <CircularProgress />
                    </div>
                }
                {
                    !isLoading &&
                    damInspections.length === 0 &&
                    <div className='fdc flx1 aic jcc'>
                        <Typography className={'mb10'} color='inherit' variant='h5'>
                            No Records
                        </Typography>
                    </div>
                }
                {
                    !isLoading &&
                    !!damInspections.length &&
                    <div className='fdc flx1 ais jcfs oya oxh pt20 pb20 pl20 pr20 drawer'>
                        {
                            damInspections.map(damInspection => (
                                <SeparatedAccordion key={damInspection.id}>
                                    <PrimaryAccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <div className='fdr jcc aic flx1'>
                                            {
                                                AppFunctionsService.formatDateTimeToDateOnly(damInspection.date) 
                                            }
                                            <span className='flx1' />
                                        </div>
                                    </PrimaryAccordionSummary>
                                    <AccordionDetails className={'fdc p0'}>
                                        <DamInspectionEntryView inspection={damInspection} />
                                    </AccordionDetails>
                                </SeparatedAccordion>
                            ))
                        }
                    </div>
                }
            </div>
        );
    };
}
